import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import * as i2 from '@upr-web-primer/locale';
import { LocaleModule } from '@upr-web-primer/locale';
import { WindowModule, WINDOW } from '@upr-web-primer/window';
import * as i1 from '@angular/router';
import { get, compact } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';

class UrlInfoModule {
}
UrlInfoModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UrlInfoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
UrlInfoModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UrlInfoModule, imports: [CommonModule, WindowModule, LocaleModule] });
UrlInfoModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UrlInfoModule, imports: [[CommonModule, WindowModule, LocaleModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UrlInfoModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, WindowModule, LocaleModule]
                }]
        }] });

class UrlInfoService {
    constructor(route, localeService, window, defaultLanguage, defaultCountry, iceUrlLocaleRegExp, TridionSite) {
        this.route = route;
        this.localeService = localeService;
        this.window = window;
        this.defaultLanguage = defaultLanguage;
        this.defaultCountry = defaultCountry;
        this.iceUrlLocaleRegExp = iceUrlLocaleRegExp;
        this.TridionSite = TridionSite;
        const locale = this.localeService.getFromStorage();
        this.info$ = new BehaviorSubject({
            path: get(this.route, 'snapshot.url', null)
                ? this.route.snapshot.url.toString().replace(/,/g, '/')
                : this.window.location.pathname,
            publication: get(this.route, 'snapshot.params.publication', ''),
            language: get(locale, 'language', this.defaultLanguage),
            country: get(locale, 'country', this.defaultCountry),
            slug: get(this.route, 'snapshot.data.slug', '')
        });
    }
    setUrlInfo(urlInfo) {
        this.urlInfo = urlInfo;
        this.info$.next(this.urlInfo);
    }
    get(route) {
        const tridionSite = this.TridionSite || 'k2';
        const path = route.url
            .toString()
            .replace(/,/g, '/')
            .replace('/' + tridionSite + '/', '/');
        let country = get(route.url, '1.path', this.defaultCountry);
        let language = get(route.url, '0.path', this.defaultLanguage);
        const publication = get(route, 'params.publication', tridionSite);
        const slug = get(route, 'data.slug', '');
        const interest = get(route, 'params.interest', '');
        language = get(route, 'params.language', language);
        country = get(route, 'params.country', country);
        const prefix = compact([language, country]).join('/');
        return {
            path: path,
            publication: publication,
            language: language,
            country: country,
            slug: slug,
            interest: interest,
            prefix: prefix
        };
    }
    getUrlPrefix() {
        const groups = this.window.location.pathname.match(this.iceUrlLocaleRegExp);
        let country = this.defaultCountry;
        let language = this.defaultLanguage;
        if (groups) {
            country = get(groups, '5', country);
            language = get(groups, '4', language);
        }
        return '/' + language + '/' + country;
    }
}
UrlInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UrlInfoService, deps: [{ token: i1.ActivatedRoute }, { token: i2.LocaleService }, { token: WINDOW }, { token: 'DefaultLanguage' }, { token: 'DefaultCountry' }, { token: 'IceUrlLocaleRegex' }, { token: 'TridionSite' }], target: i0.ɵɵFactoryTarget.Injectable });
UrlInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UrlInfoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UrlInfoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }, { type: i2.LocaleService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['DefaultLanguage']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['DefaultCountry']
                }] }, { type: RegExp, decorators: [{
                    type: Inject,
                    args: ['IceUrlLocaleRegex']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['TridionSite']
                }] }]; } });

class UrlInfoResolver {
    constructor(urlInfo) {
        this.urlInfo = urlInfo;
    }
    resolve(route) {
        const urlInfo = this.urlInfo.get(route);
        this.urlInfo.setUrlInfo(urlInfo);
        return urlInfo;
    }
}
UrlInfoResolver.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UrlInfoResolver, deps: [{ token: UrlInfoService }], target: i0.ɵɵFactoryTarget.Injectable });
UrlInfoResolver.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UrlInfoResolver, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UrlInfoResolver, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: UrlInfoService }]; } });

export { UrlInfoModule, UrlInfoResolver, UrlInfoService };
